import { render, staticRenderFns } from "./ac-view.vue?vue&type=template&id=237c1e5f&"
import script from "./ac-view.vue?vue&type=script&lang=js&"
export * from "./ac-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports